import * as React from "react"

import { resolveLinkHref } from "../../shared-components/seo/canonical-tag/utils"
import { useLocale } from "../../utils/hooks/use-locale"
import * as styles from "./index.module.scss"

type Props = {
  to: string
  text: string
  variant?: "small" | "medium" | "large" | "xLarge"
  arrowDirection?: "left" | "right"
  style?: string
  target?: string
}

/** @deprecated */
function LinkWithArrowDeprecated({
  to,
  text,
  arrowDirection = "right",
  variant = "small",
  style,
  target,
}: Props) {
  const locale = useLocale()

  const isRight = arrowDirection === "right"
  const arrow = (
    <div className={`${styles.arrow} ${isRight ? "" : styles.leftArrow}`}>
      
    </div>
  )

  return (
    <a
      href={resolveLinkHref(to, locale)}
      className={`${styles.link} ${styles[variant]} ${style}`}
      tabIndex={0}
      data-testid={`LinkWithArrow-${text}`}
      target={target}
    >
      {!isRight && arrow}
      <span>{text}</span>
      {isRight && arrow}
    </a>
  )
}

export default LinkWithArrowDeprecated
